import { Button } from "@chakra-ui/react";
import { useTranslationContext } from "../context/TranslationContext";

export default function AdvancedConfigurationToggle({
    show, toggle
}) {
    const { STRINGS } = useTranslationContext();
    return (
        <>
        {show ? (
            <Button colorScheme="gray" onClick={toggle} border="1px" borderColor={"green"} borderRadius="4px">
                {STRINGS.advancedConfiguration}
            </Button>
        ) : (
            <Button colorScheme="gray" onClick={toggle} border="1px" borderColor={"green"} borderRadius="4px">
                 {STRINGS.advancedConfiguration}
            </Button>
        )}
        </>

    );
}